var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { WOH_AM_I_DATA, NOTIFICATION } from "../api/url";
import { LOCAL_STORAGE_KEYS } from "../constants";
export var getWhoAmIToken = function () {
    var authStr = localStorage.getItem(WOH_AM_I_DATA);
    if (authStr) {
        var authJSON = JSON.parse(authStr);
        return authJSON === null || authJSON === void 0 ? void 0 : authJSON.data;
    }
    return null;
};
export var getUserAuthToken = function () {
    var authStr = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_LOGIN_DATA);
    if (authStr) {
        var authJSON = JSON.parse(authStr);
        return authJSON.data.Token;
    }
    return null;
};
export var setLocalStorageItem = function (key, data) {
    localStorage.setItem(key, JSON.stringify(data));
};
export var getLocalStorageItem = function (key) {
    try {
        var item = localStorage.getItem(key);
        if (item) {
            return JSON.parse(item);
        }
        return null;
    }
    catch (error) {
        console.error(error);
        return null;
    }
};
export var removeLocalStorageItem = function (key) {
    localStorage.removeItem(key);
};
export var clearLocalStorage = function () {
    localStorage.clear();
};
export var saveNotifications = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var myNotifications, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getSaveNotifications()];
            case 1:
                myNotifications = _a.sent();
                myNotifications.unshift(body);
                localStorage.setItem(NOTIFICATION, JSON.stringify(myNotifications));
                return [2 /*return*/, myNotifications];
            case 2:
                error_1 = _a.sent();
                console.log("error", error_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var getSaveNotifications = function () {
    try {
        var item = localStorage.getItem(NOTIFICATION);
        if (item) {
            return JSON.parse(item);
        }
        return [];
    }
    catch (error) {
        console.log("error", error);
    }
};
export var calculateTimeDifference = function (start, end) {
    if (start && end) {
        if (!(start instanceof Date) || !(end instanceof Date)) {
            // throw new Error("Both start and end must be valid Date objects.");
        }
        var diff = end.getTime() - start.getTime();
        if (diff < 0) {
            // throw new Error("The end time must be after the start time.");
        }
        var hours = Math.floor(diff / (1000 * 60 * 60));
        var minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
        var seconds = Math.floor(diff % (1000 * 60) / 1000);
        var milliseconds = diff % 1000;
        return {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            milliseconds: milliseconds
        };
    }
    else {
        return {};
    }
};
